import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.function.name";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//引用接口
import { queryUserTreeList, queryDepartTreeList, querySiteList, queryPipeSystem, inspectionEvaluationScore, EvaluationLineChart, PatrolStatistics, AverageStarValue, DispatchStatisticsChart, evaluationStatisticsChart, DispatchRoutingChart, DispatchComparisonDiagram } from '@/api/api';
import monthSelect from '@/components/date/monthSelect';
import yearSelect from '@/components/date/yearSelect';
import SelectSiteListModal from '@/views/assets/SelectSiteListModal';
export default {
  components: {
    monthSelect: monthSelect,
    yearSelect: yearSelect,
    SelectSiteListModal: SelectSiteListModal
  },
  data: function data() {
    return {
      showPie: true,
      //请求参数
      query: {
        departId: '',
        siteId: '',
        pipeNetworkId: '',
        type: 1,
        dateType: 1,
        quantum: ''
      },
      //人员数据
      userTree: [],
      //部门数据
      deptTree: [],
      //站点数据
      siteTree: [],
      //官网数据
      PipeSystem: [],
      //站点数据
      selectedSite: [],
      //工单值
      tabKey: 1
    };
  },
  watch: {
    'query.type': function queryType() {
      if (this.query.type == '1') {
        this.query.departId = '';
        this.query.siteId = '';
        this.query.pipeNetworkId = '';
      } else if (this.query.type == '2') {
        this.query.userId = '';
        this.query.siteId = '';
        this.query.pipeNetworkId = '';
      } else if (this.query.type == '3') {
        this.query.userId = '';
        this.query.departId = '';
        this.query.pipeNetworkId = '';
      } else if (this.query.type == '4') {
        this.query.userId = '';
        this.query.siteId = '';
        this.query.departId = '';
      }
    }
  },
  mounted: function mounted() {
    this.query.userId = JSON.parse(localStorage.getItem('pro__Login_Userinfo')).value.id;
    this.loadUserTree();
    this.loadDepartTree();
    this.loadSiteTree();
    this.loadPipeNetworkTree();
    this.queryButton();
  },
  methods: {
    queryButton: function queryButton() {
      if (this.tabKey == 1) {
        this.getInspectionEvaluationScore();
        this.getInspectionEvaluation();
        this.getPatrolStatisticsdata();
        this.getAverageStarValue();
      } else if (this.tabKey == 2) {
        this.getObtainDispatch();
        this.getDispatchStatistics();
        this.getInspectionedata();
        this.getPatrolDispatchdata();
      }
    },
    //加载人员信息
    loadUserTree: function loadUserTree() {
      var that = this;
      that.userTree = []; // 用户

      queryUserTreeList().then(function (res) {
        //调用接口
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }
        }
      });
    },
    //加载部门信息
    loadDepartTree: function loadDepartTree() {
      var that = this;
      that.deptTree = []; // 部门

      queryDepartTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.deptTree.push(temp);
          }
        }
      });
    },
    selectSite: function selectSite() {
      var _this = this;

      this.$nextTick(function () {
        _this.$refs.SiteListModal.add(_this.selectedSite, _this.siteIds);
      });
    },
    //站点提示框
    // 子modal回调
    choseSite: function choseSite(siteList) {
      this.selectedSite = [siteList[0].name];
      this.query.siteId = siteList[0].id;
    },
    //加载站点信息
    loadSiteTree: function loadSiteTree() {
      var that = this;
      that.siteTree = []; // 站点

      querySiteList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.siteTree.push(temp);
          }
        }
      });
    },
    //加载管网信息
    loadPipeNetworkTree: function loadPipeNetworkTree() {
      var that = this;
      that.PipeSystem = []; // 网关

      queryPipeSystem().then(function (res) {
        if (res.success) {
          that.PipeSystem = res.result.records;
          that.query.pipeNetworkId = res.result.records[0].id;
        }
      });
    },
    // 月变化
    monthChange: function monthChange(value) {
      this.query.quantum = value;
    },
    // 年变化
    yearChange: function yearChange(value) {
      this.query.quantum = value;
    },
    //获取巡检单饼图数据
    getInspectionEvaluationScore: function getInspectionEvaluationScore() {
      var _this2 = this;

      var that = this;
      inspectionEvaluationScore(this.query).then(function (res) {
        // console.log(res)
        if (res.success) {
          var ary = [];
          res.result.forEach(function (element) {
            ary.push({
              value: element.starNum,
              name: element.starLevel
            });
          });

          _this2.drawLine(ary);
        }
      });
    },
    //获取派工单饼图数据
    getDispatchStatistics: function getDispatchStatistics() {
      var _this3 = this;

      DispatchStatisticsChart(this.query).then(function (res) {
        // console.log(res)
        if (res.success) {
          var ary = [];
          res.result.forEach(function (element) {
            ary.push({
              value: element.starNum,
              name: element.starLevel
            });
          });

          _this3.drawLine(ary);
        }
      });
    },
    //获取巡检单考评折线图数据   
    getInspectionEvaluation: function getInspectionEvaluation() {
      var _this4 = this;

      var query = _objectSpread({}, this.query);

      EvaluationLineChart(query).then(function (res) {
        // console.log(res)
        if (res.success) {
          var data = [];
          res.result.forEach(function (element) {
            data.push({
              TimeF: element.dateStr,
              value: element.starNumAvg,
              Pvalue: element.starNum,
              StarName: element.starLevel
            });
          }); //日期数据

          var xData = [];
          data.forEach(function (e) {
            xData.push(e.TimeF);
          }); //星值占比数数据

          var YData = [];
          data.forEach(function (e) {
            YData.push(e.starNum);
          }); // debugger
          //星值平均数数据

          var Data = [];
          data.forEach(function (e) {
            Data.push(e.value);
          });

          _this4.getPatrolChart(xData, YData, Data);

          console.log(res);
        }
      });
    },
    //获取巡检单考评折线图数据   
    getInspectionedata: function getInspectionedata() {
      var _this5 = this;

      var query = _objectSpread({}, this.query);

      evaluationStatisticsChart(query).then(function (res) {
        // console.log(res)
        if (res.success) {
          var data = [];
          res.result.forEach(function (element) {
            data.push({
              TimeF: element.dateStr,
              value: element.starNumAvg,
              Pvalue: element.starNum,
              StarName: element.starLevel
            });
          }); //日期数据

          var xData = [];
          data.forEach(function (e) {
            xData.push(e.TimeF);
          }); //星值占比数数据

          var YData = [];
          data.forEach(function (e) {
            YData.push(e.starNum);
          }); // debugger
          //星值平均数数据

          var Data = [];
          data.forEach(function (e) {
            Data.push(e.value);
          });

          _this5.getPatrolChart(xData, YData, Data); // console.log(res)

        }
      });
    },
    //获取巡检单平均星值统计数据
    getPatrolStatisticsdata: function getPatrolStatisticsdata() {
      var _this6 = this;

      var query = _objectSpread({}, this.query);

      PatrolStatistics(query).then(function (res) {
        // console.log(res)
        if (res.success) {
          _this6.ringChart(res.result.thisMonth, res.result.monthOnMonth);
        }
      });
    },
    //获取派工单平均星值统计数据
    getPatrolDispatchdata: function getPatrolDispatchdata() {
      var _this7 = this;

      var query = _objectSpread({}, this.query);

      DispatchRoutingChart(query).then(function (res) {
        // console.log(res)
        if (res.success) {
          _this7.ringChart(res.result.thisMonth, res.result.monthOnMonth);
        }
      });
    },
    //获取巡检单巡检统计数据
    getAverageStarValue: function getAverageStarValue() {
      var _this8 = this;

      var query = _objectSpread({}, this.query);

      AverageStarValue(query).then(function (res) {
        //  console.log(res)
        if (res.success) {
          var tdata = [];
          res.result['巡检类型'].forEach(function (element) {
            tdata.push({
              name: element.text,
              value: element.num
            });
          });
          var sdata = [];
          res.result['巡检结果'].forEach(function (element) {
            sdata.push({
              name: element.text,
              value: element.num
            });
          });
          var pdata = [];
          res.result['巡检进度'].forEach(function (element) {
            pdata.push({
              name: element.text,
              value: element.num
            });
          });

          _this8.comparisonD(tdata, sdata, pdata);
        }
      });
    },
    //获取派工单巡检统计数据
    getObtainDispatch: function getObtainDispatch() {
      var _this9 = this;

      this.showPie = false;
      this.$nextTick(function () {
        _this9.showPie = true;

        _this9.$nextTick(function () {
          var query = _objectSpread({}, _this9.query);

          DispatchComparisonDiagram(query).then(function (res) {
            // console.log(res)
            if (res.success) {
              var tdata = [];
              res.result['任务类型'].forEach(function (element) {
                tdata.push({
                  name: element.text,
                  value: element.num
                });
              });
              var sdata = [];
              res.result['任务级别'].forEach(function (element) {
                sdata.push({
                  name: element.text,
                  value: element.num
                });
              });
              var pdata = [];
              res.result['工单状态'].forEach(function (element) {
                pdata.push({
                  name: element.text,
                  value: element.num
                });
              });
              var qatqa = [];
              res.result['故障来源'].forEach(function (element) {
                qatqa.push({
                  name: element.text,
                  value: element.num
                });
              });

              _this9.comparison(tdata, sdata, pdata, qatqa);
            }
          });
        });
      });
    },
    //环形图
    drawLine: function drawLine(data) {
      // 1、基于准备好的dom，初始化echarts实例
      var myChart = this.$echarts.init(this.$refs.ProportionEvaluation); //2、构造图表数据

      var option = {
        title: {
          text: '考评星值占比',
          left: 'center'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          bottom: '0%',
          left: 'center'
        },
        series: [{
          name: '星级占比',
          type: 'pie',
          radius: [40, 130],
          center: ['50%', '50%'],
          //   roseType: 'area',
          itemStyle: {
            borderRadius: 5
          },
          data: data
        }]
      }; // 3、绘制图表

      myChart.setOption(option);
    },
    //巡检单折线图
    getPatrolChart: function getPatrolChart(xData, YData, Data) {
      // 基于准备好的dom，初始化echarts实例  这个和上面的main对应  
      var myChart = this.$echarts.init(this.$refs.AppraisalS); // 指定图表的配置项和数据

      var option = {
        title: {
          text: '考评星值图',
          left: 'center'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // type: "cross",
            label: {
              backgroundColor: "#e6b600"
            }
          }
        },
        grid: {
          left: '5%',
          right: '4%',
          bottom: '3%',
          top: '15%',
          containLabel: true
        },
        xAxis: {
          type: "category",
          data: xData,
          boundaryGap: false
        },
        yAxis: {
          type: "value"
        },
        emphasis: {
          itemStyle: {
            color: 'green',
            //这里设置的拐点颜色
            borderColor: "green",
            //  拐点边框颜色
            borderWidth: 8,
            //  拐点边框宽度
            shadowColor: "yellow",
            //  阴影颜色
            shadowBlur: 5 //  阴影渐变范围控制

          }
        },
        series: [{
          name: "星值平均数",
          type: "line",
          data: Data,
          stack: "Total",
          //数据堆叠
          smooth: true,
          //折线图平滑效果 变成曲线图
          emphasis: {
            //设置高亮的图形样式和标签样式
            focus: "series" //只显示选中的内容高亮

          }
        }]
      }; // 使用刚指定的配置项和数据显示图表。

      myChart.setOption(option);
    },
    //环比图
    ringChart: function ringChart(e, data) {
      var _this10 = this;

      // 基于准备好的dom，初始化echarts实例  这个和上面的main对应
      var myChart = this.$echarts.init(this.$refs.EvaluationM); // 指定图表的配置项和数据

      var option = {
        title: {
          text: '考评星值图',
          left: 'center'
        },
        tooltip: {
          formatter: '{a} <br/>{b} : {c}%'
        },
        series: [{
          name: this.query.dateType == '1' ? '平均星值环比' : '平均星值同比',
          type: 'gauge',
          max: 5,
          progress: {
            show: true
          },
          detail: {
            valueAnimation: true,
            fontSize: '18',
            padding: [50, 0, 0, 0],
            formatter: function formatter(value) {
              if (_this10.query.dateType == '1') {
                if (value > 0) {
                  return e + '星级\n\n比上月上升' + value + '星级';
                } else if (value == 0) {
                  return e + '星级\n\n与上月相同';
                } else if (value < 0) {
                  return e + '星级\n\n比上月下降' + value + '星级';
                }
              } else if (_this10.query.dateType == '2') {
                if (value > 0) {
                  return e + '星级\n\n比去年上升' + value + '星级';
                } else if (value == 0) {
                  return e + '星级\n\n与去年相同';
                } else if (value < 0) {
                  return e + '星级\n\n比去年下降' + value + '星级';
                }
              }
            }
          },
          data: [{
            value: data,
            name: this.query.dateType == '1' ? '平均星值环比' : '平均星值同比'
          }]
        }]
      }; // 使用刚指定的配置项和数据显示图表。

      myChart.setOption(option);
    },
    //巡检单对比图
    comparisonD: function comparisonD(tdata, sdata, pdata) {
      var _this11 = this;

      this.showPie = false;
      this.$nextTick(function () {
        _this11.showPie = true;

        _this11.$nextTick(function () {
          // 基于准备好的dom，初始化echarts实例  这个和上面的main对应
          var myChart = _this11.$echarts.init(_this11.$refs.EvaluationC); // 指定图表的配置项和数据


          var option = {
            title: [{
              text: '巡检对比图',
              left: 'center'
            }, {
              subtext: '巡检类型',
              left: '16.67%',
              top: '83%',
              textAlign: 'center',
              subtextStyle: {
                color: '#00000',
                fontSize: 16
              }
            }, {
              subtext: '巡检结果',
              left: '50%',
              top: '83%',
              textAlign: 'center',
              subtextStyle: {
                color: '#00000',
                fontSize: 16
              }
            }, {
              subtext: '巡检完成度',
              left: '83.33%',
              top: '83%',
              textAlign: 'center',
              subtextStyle: {
                color: '#00000',
                fontSize: 16
              }
            }],
            tooltip: {
              trigger: 'item'
            },
            grid: {
              left: '1%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            series: [{
              type: 'pie',
              radius: '45%',
              center: ['50%', '50%'],
              data: tdata,
              label: {
                position: 'outer',
                alignTo: 'none',
                bleedMargin: 5,
                show: true
              },
              left: 0,
              right: '66.6667%',
              top: 0,
              bottom: 0
            }, {
              type: 'pie',
              radius: '45%',
              center: ['50%', '50%'],
              data: sdata,
              label: {
                position: 'outer',
                alignTo: 'labelLine',
                bleedMargin: 5
              },
              left: '33.3333%',
              right: '33.3333%',
              top: 0,
              bottom: 0
            }, {
              type: 'pie',
              radius: '45%',
              center: ['50%', '50%'],
              data: pdata,
              label: {
                position: 'outer',
                alignTo: 'edge',
                margin: 20
              },
              left: '66.6667%',
              right: 0,
              top: 0,
              bottom: 0
            }]
          }; // 使用刚指定的配置项和数据显示图表。

          myChart.setOption(option);
        });
      });
    },
    //派工单对比图
    comparison: function comparison(tdata, sdata, pdata, qatqa) {
      var myChart = this.$echarts.init(this.$refs.EvaluationC); // 指定图表的配置项和数据

      var option = {
        title: [{
          text: '巡检对比图',
          left: 'center'
        }, {
          subtext: '故障来源:',
          left: '10%',
          top: '22%',
          textAlign: 'center',
          subtextStyle: {
            color: '#00000',
            fontSize: 16
          }
        }, {
          subtext: '任务类型:',
          left: '63%',
          top: '22%',
          textAlign: 'center',
          subtextStyle: {
            color: '#00000',
            fontSize: 16
          }
        }, {
          subtext: '任务级别:',
          left: '10%',
          top: '70%',
          textAlign: 'center',
          subtextStyle: {
            color: '#00000',
            fontSize: 16
          }
        }, {
          subtext: '工单状态:',
          left: '63%',
          top: '70%',
          textAlign: 'center',
          subtextStyle: {
            color: '#00000',
            fontSize: 16
          }
        }],
        tooltip: {
          trigger: 'item'
        },
        grid: {
          left: '10%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        series: [{
          type: 'pie',
          radius: '33%',
          center: ['25%', '28%'],
          data: tdata,
          left: 0,
          top: 0,
          bottom: 0
        }, {
          type: 'pie',
          radius: '33%',
          center: ['55%', '28%'],
          data: sdata,
          left: '50%',
          top: 0,
          bottom: 0
        }, {
          type: 'pie',
          radius: '33%',
          center: ['25%', '75%'],
          data: pdata,
          left: 0,
          top: 0,
          bottom: 0
        }, {
          type: 'pie',
          radius: '33%',
          center: ['55%', '75%'],
          data: qatqa,
          left: '50%',
          top: 0,
          bottom: 0
        }]
      }; // 使用刚指定的配置项和数据显示图表。

      myChart.setOption(option);
    }
  }
};